'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'bags-shopping';
var width = 576;
var height = 512;
var aliases = [128717];
var unicode = 'f847';
var svgPathData = ['M0 160L0 384c0 35.3 28.7 64 64 64l80 0 0-160c0-61.9 50.1-112 112-112l192 0 0-16c0-35.3-28.7-64-64-64l-64 0 0-32c0-53-43-96-96-96s-96 43-96 96l0 32-64 0C28.7 96 0 124.7 0 160zM176 64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 32-96 0 0-32zM288 312l0 40c0 53 43 96 96 96s96-43 96-96l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24z', 'M256 224c-35.3 0-64 28.7-64 64l0 160c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-160c0-35.3-28.7-64-64-64l-256 0zm80 88l0 40c0 26.5 21.5 48 48 48s48-21.5 48-48l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 53-43 96-96 96s-96-43-96-96l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBagsShopping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;